$(function () {
  var $body = $('body');

  // only works on search result page
  if (!$body.hasClass('page-type--searchresultspage')) return;

  var searchApi = '/umbraco/api/searchapi/search/';
  var courseApi = '/umbraco/api/searchapi/filtercourses/';
  var allPageApi = '/umbraco/api/searchapi/filterallpages/';
  var courseListing, courseFilters, otherListing, studyAreas;

  var $courseCount = $('#search-results-course-count');
  var $otherCount = $('#search-results-other-count');
  var $searchForm = $('#search-form');
  var $otherResultsTab = $('a[href="#other-results"]');

  var GA_UNSUCCESSFUL_SEARCH = true;

  function getQuery() {
    var queryString = window.location.search.slice(1); // ignore ? at the beginning
    var queryPairs = queryString.split('&');
    for (var i = 0; i < queryPairs.length; i++) {
      var queryKeyValue = queryPairs[i].split('=');
      if (queryKeyValue[0] === 'query') {
        return unescape(queryKeyValue[1]).replace(/\+/g, ' ');
      }
    }
    return null;
  }

  studyAreas = new Vue({
    el: '#study-areas',
    data: {
      areas: courseAreaResults // from initial load
    }
  });

  // search result list instance
  otherListing = new Vue({
    el: '.search-results-listing',
    data: otherPageResults && otherPageResults.items ? otherPageResults : {items: [], pageNumber: 1, pageSize: 10, totalPages: 0, totalItems: 0}, // from the initial load data
    methods: {

      // highlight the keywords
      parseDescription: function (description) {
        return description;
      },

      prev: function () {
        this.fetch(getQuery(), Math.max(1, this.pageNumber - 1));
      },

      next: function () {
        this.fetch(getQuery(), Math.min(this.pageNumber + 1, this.totalPages));
      },

      update: function (data) {
        this.pageSize = data.pageSize;
        this.pageNumber = data.pageNumber;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
        this.items = [...data.items];

        $otherCount.text('(' + this.totalItems + ')');
      },

      fetch: function (keyword, page) {
        var vm = this;
        $.getJSON(allPageApi, {
          page: page || 1,
          query: keyword
        }, function (data) {
          vm.update(data);
        })
      }
    }
  });

  // course list instance
  courseListing = new Vue({
    el: '.courses-listing',
    data: courseResults && courseResults.items ? courseResults : {items: [], pageNumber: 1, pageSize: 10, totalPages: 0, totalItems: 0}, // from the initial load data
    methods: {

      prev: function () {
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedMode.value,
            Math.max(1, this.pageNumber - 1));
      },

      next: function () {
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedMode.value,
            Math.min(this.pageNumber + 1, this.totalPages));
      },

      reset: function () {
        courseFilters.fetchOnUpdate = false; // disable fetch-on-update for a moment
        courseFilters.selectedCampus = courseFilters.campuses[0];
        courseFilters.selectedMode = courseFilters.modes[0];
        courseFilters.fetchOnUpdate = true;

        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedMode.value, 1);
      },

      update: function (data) {
        this.pageSize = data.pageSize;
        this.pageNumber = data.pageNumber;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
        this.items = [...data.items];

        $courseCount.text('(' + this.totalItems + ')');
      },

      ga: function () {
        GA_UNSUCCESSFUL_SEARCH = false;

        gtag && gtag('event', 'Select a course', {
          event_category: 'Search Results',
          transport_type: 'beacon'
        });
      },

      fetch: function (campus, mode, page) {
        var vm = this;
        var req = {
          query: getQuery(),
          // we don't need the umbracopageId parameter here
          page: page || 1,
          campus: campus,
          studymode: mode
        };

        $.getJSON(courseApi, req, function (data) {
          vm.update(data);
        })
      }
    }
  });

  // filter instance
  courseFilters = new Vue({
    el: '.filters--courses-listing',
    data: function () {
      var data = {
        campuses: LOCATIONS,
        modes: STUDY_MODES,
        fetchOnUpdate: true
      };

      data.selectedCampus = data.campuses[0];
      data.selectedMode = data.modes[0];
      return data;
    },
    computed: {
      selectedCampusLabel: function () {
        if (this.selectedCampus === null)
          return 'Any Campus';

        return this.selectedCampus.label;
      },
      selectedModeLabel: function () {
        if (this.selectedMode === null)
          return 'Any Mode';

        return this.selectedMode;
      },
    },
    watch: {
      selectedCampus: function (newCampus) {
        if (this.fetchOnUpdate)
          courseListing.fetch(newCampus.value, this.selectedMode.value)
      },
      selectedMode: function (newMode) {
        if (this.fetchOnUpdate)
          courseListing.fetch(this.selectedCampus.value, newMode.value)
      }
    },
    methods: {
      selectCampus: function (evt, campus) {
        this.toggleDropdown(evt, false);
        this.selectedCampus = campus;
      },

      isCampusSelected: function (campus) {
        return this.selectedCampus === campus;
      },

      isModeSelected: function (mode) {
        return this.selectedMode === mode;
      },

      selectMode: function (evt, mode) {
        this.toggleDropdown(evt, false);
        this.selectedMode = mode;
      },

      toggleDropdown: function (evt, flag) {
        var $filter = $(evt.target).parents('.filter');
        $filter.toggleClass('open', flag);
      },
    }
  });

  $searchForm.on('submit', function (e) {
    var keyword = this.query.value.trim();
    if (!keyword) {
      this.query.focus();

    } else {
      $.getJSON(searchApi, {
        query: keyword
      }, function (data) {
        courseListing.update(data.CourseResults);
        otherListing.update(data.OtherPageResults);
        studyAreas.areas = data.CourseAreaResults;

        if (!data.CourseResults.totalItems && data.OtherPageResults.totalItems) {
          $otherResultsTab.tab('show');
        }

        gtag && gtag('event', 'Clarify Search', {
          event_category: 'Search Results',
          transport_type: 'beacon'
        });

        window.history.pushState({
          keyword: keyword
        }, 'Search', '?query=' + keyword);
      });
    }

    e.preventDefault();
  });

  window.addEventListener('popstate', function (e) {
    var keyword = getQuery();
    if (!keyword) return;

    $searchForm.get(0).query.value = keyword;

    // $.getJSON(searchApi, {
    //   query: keyword
    // }, function (data) {
    //   courseListing.update(data.CourseResults);
    //   otherListing.update(data.OtherPageResults);
    // });
  });

  $searchForm.get(0).query.value = getQuery();

  if ((!courseListing || !courseListing.items) && otherPageResults.totalItems) {
    console.log(courseListing);
    $otherResultsTab.tab('show');
  }

  var GA_REST_OF_SITE_TAB_SENT = false;
  $otherResultsTab.on('click', function(){
    if(!GA_REST_OF_SITE_TAB_SENT) {
      GA_REST_OF_SITE_TAB_SENT = true;

      gtag && gtag('event', 'Rest of the site tab', {
        event_category: 'Search Results',
        transport_type: 'beacon'
      });
    }
  });

  $('a.search-results-item__link').on('click', function(){
    GA_UNSUCCESSFUL_SEARCH = false;
  });

  $(window).on('unload', function(){
    if(GA_UNSUCCESSFUL_SEARCH) {
      gtag && gtag('event', 'Unsuccessful search', {
        event_category: 'Search Results',
        transport_type: 'beacon'
      });
    }
  })
});